import { reducer as connectWalletReducer } from "./connectWallet";
import { reducer as statsReducer } from "./statsCounts";
import { combineReducers } from "redux";
const reducers = combineReducers({
  wallet: connectWalletReducer,
  stats: statsReducer,
});

export default reducers;
